//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BScroll from "better-scroll";
import search_icon from "@/assets/img/icon/search.png";
import MyInput from "@/components/SearchInput";
export default {
  name: "search",
  components: {
    MyInput
  },
  data() {
    return {
      search_icon: search_icon,
      historySearch: [],
      hotSearch: [],
      bscroll: ""
    };
  },
  methods: {
    initScroll() {
      let wrapper = document.querySelector(".search");
      if (!this.bscroll) {
        this.bscroll = new BScroll(wrapper, {
          click: true,
          bounce: {
            top: false,
            bottom: false,
            left: false,
            right: false
          }
        });
      } else {
        this.bscroll.refresh();
      }
    },
    handleSearch(keyWord) {
      if (!keyWord || keyWord.length == 0) {
        this.$vux.toast.text("请输入搜索关键字");
      } else {
        this.$router.push({
          path: "/searchResult",
          query: { keyWord: keyWord }
        });
      }
    },
    getHotBookList() {
      this.$http("post", "/book/hot", {
        current: 1,
        size: 10
      }).then(res => {
        res.data.forEach(book => {
          if (book["ztming"] !== "") {
            this.hotSearch.push(book["ztming"]);
          }
        });
        this.$nextTick(() => {
          this.initScroll();
        });
      });
    },
    returnHome() {
      window.removeEventListener("popstate", this.returnHome);
      this.$router.push({
        name: "Home"
      });
    }
  },
  mounted() {
    this.initScroll();
    this.getHotBookList();
    window.addEventListener("popstate", this.returnHome, false);
  },
  destroyed() {
    window.removeEventListener("popstate", this.returnHome);
  }
};
